/* global MessageEvent window Window */

export interface RemoteAction {
  name: string;
  onExecute: (data: any) => Promise<Record<string, any>>;
}

(window as any).remoteActions = [] as RemoteAction[];

export function registerAction(command: RemoteAction) {
  (window as any).remoteActions.push(command);
}

export async function handleRemoteAction(event: MessageEvent<any>) {
  // Just to show that the event was received
  const action = event.data?.action;
  const data = event.data?.data;
  const callId = event.data?.callId;
  const targetCommand = ((window as any).remoteActions as RemoteAction[]).find((command) => command.name === action);
  if (targetCommand) {
    const response = await targetCommand.onExecute(data);
    if (response && callId) {
      const originWindow = event.source as Window;
      originWindow.postMessage(
        {
          callId,
          response,
        },
        event.origin
      );
    }
  }
}
